import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpSharedIconBubbles.scss';

// Components
import EmailIcon from 'dibs-vg/dist/react/email';
import PdpSharedSendToFriendModalLoader from '../PdpSharedModals/PdpSharedSendToFriendModal/PdpSharedSendToFriendModalLoader';

// helpers
import { trackEmailClick } from '../tracking/iconBubblesTracking';
import get from 'lodash.get';

class PdpSharedIconBubbleEmail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
        };

        this.onClick = this.onClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.setState({ modalOpen: false });
    }

    onClick() {
        this.setState({ modalOpen: true }, () => {
            // fire tracking
            trackEmailClick(this.props.item.serviceId);
        });
    }

    render() {
        const { item, user, viewer } = this.props;
        const { isPdpStfEnabled } = viewer || {};

        if (!isPdpStfEnabled) {
            return null;
        }

        const senderEmail = get(user, 'profile.email') || '';
        const { modalOpen } = this.state;
        const selectedItem = {
            itemId: get(item, 'serviceId') || '',
            title: get(item, 'title') || '',
            src: get(item, 'photos[0].largePath') || '',
        };

        return (
            <div className={styles.bubble} onClick={this.onClick}>
                <EmailIcon className={styles.icon} />
                <PdpSharedSendToFriendModalLoader
                    type="PDP"
                    modalOpen={modalOpen}
                    relay={this.props.relay}
                    senderEmail={senderEmail}
                    selectedItems={[selectedItem]}
                    closeModal={this.closeModal}
                />
            </div>
        );
    }
}

PdpSharedIconBubbleEmail.propTypes = {
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export default createFragmentContainer(PdpSharedIconBubbleEmail, {
    viewer: graphql`
        fragment PdpSharedIconBubbleEmail_viewer on Viewer {
            isPdpStfEnabled: isEnabled(key: "enablePdpStf")
        }
    `,
    item: graphql`
        fragment PdpSharedIconBubbleEmail_item on Item {
            serviceId
            title
            photos {
                largePath
            }
        }
    `,
    user: graphql`
        fragment PdpSharedIconBubbleEmail_user on User {
            profile {
                email
            }
        }
    `,
});
